<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" name="Dialoog" [steps]="pages().length" [progress]="index()" />

  <rid-mechanic-content>
    <rid-mechanic-title [title]="'Lees de tekst om de beurt voor'" />

    <rid-horizontal-pages [pageCount]="pages().length" (navigated)="index.set($event)">
      @for (page of pages(); track $index) {
        <div class="grid h-max w-md gap-4 xl:w-xl">
          @for (line of page; track $index) {
            <rid-dialog-line [line]="line" [index]="$index" />
          }
        </div>
      }
    </rid-horizontal-pages>

    @if (index() === pages().length - 1) {
      <rid-bottom-button content="Volgende" (clicked)="finished.emit()" />
    }
  </rid-mechanic-content>
</rid-mechanic-wrapper>
